import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lane", "task"]

  connect() {
    this.setupDraggables()
    this.setupDroppables()
  }

  setupDraggables() {
    this.taskTargets.forEach((task) => {
      task.addEventListener("dragstart", this.handleDragStart.bind(this))
      task.addEventListener("dragend", this.handleDragEnd.bind(this))
    })
  }

  setupDroppables() {
    this.laneTargets.forEach((zone) => {
      zone.addEventListener("dragover", this.handleDragOver.bind(this))
      zone.addEventListener("drop", this.handleDrop.bind(this))
    })
  }

  handleDragStart(event) {
    event.target.classList.add("is-dragging")
    event.dataTransfer.effectAllowed = "move"
  }

  handleDragEnd(event) {
    event.target.classList.remove("is-dragging")
  }

  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const zone = event.currentTarget
    const bottomTask = this.insertAboveTask(zone, event.clientY)
    const curTask = this.element.querySelector(".is-dragging")

    if (!curTask) return

    if (!bottomTask) {
      zone.appendChild(curTask)
    } else {
      zone.insertBefore(curTask, bottomTask)
    }
  }

  handleDrop(event) {
    event.preventDefault()
  }

  insertAboveTask(zone, mouseY) {
    const els = zone.querySelectorAll(".task:not(.is-dragging)")

    let closestTask = null
    let closestOffset = Number.NEGATIVE_INFINITY

    els.forEach((task) => {
      const { top } = task.getBoundingClientRect()
      const offset = mouseY - top

      if (offset < 0 && offset > closestOffset) {
        closestOffset = offset
        closestTask = task
      }
    })

    return closestTask
  }
}
